import { DocumentType } from '@synergy/models';

import { Demand } from '../../demands/models/demand';
import { Inquiry } from '../../inquiries/models/inquiry';
import { PurchaseOrder } from '../../purchase-orders/models/purchaseOrder';
import { SalesOrder } from '../../sales-orders/models/salesOrder';
import { TransitionSource } from '../models/type-transition-source';

export const getDocumentTypeFromSource = (source: TransitionSource): DocumentType | null => {
    if (source instanceof Inquiry) {
        return DocumentType.Inquiry;
    }
    if (source instanceof PurchaseOrder) {
        return DocumentType.PurchaseOrder;
    }
    if (source instanceof SalesOrder) {
        return DocumentType.SalesOrder;
    }
    if (source instanceof Demand) {
        return DocumentType.Demand;
    }
    return null;
};
